import { type ComputedRef, type DeepReadonly, type Ref, ref } from 'vue'

import type { ContentCard } from '../PersonalizedFeed.utils'

export function useFallbackError({
  activeTabIndex,
  brazeUnavailable,
  fallbackCards,
}: {
  activeTabIndex: DeepReadonly<Ref<number>>
  brazeUnavailable: DeepReadonly<Ref<boolean>>
  fallbackCards: ComputedRef<ContentCard[]>
}) {
  const showFallback = ref(false)
  const showErrorState = ref(false)
  const firstTabStatus = ref<'error' | 'success' | 'pending'>('pending')

  function resetFallbackErrorState() {
    showFallback.value = false
    showErrorState.value = false
  }

  function onCardError() {
    // if there is an error on a non-first tab, we display the error state. We don't display the fallback in this case
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    if (activeTabIndex.value > 0) {
      showErrorState.value = true

      return
    }

    if (firstTabStatus.value === 'pending') {
      firstTabStatus.value = 'error'
    }

    // if an error was generated for the fallback of the 1st tab, we display the error message
    if (showFallback.value || brazeUnavailable.value) {
      showErrorState.value = true

      return
    }

    // if an error was generated for the content card of the 1st tab, we display the fallback if there is one
    if (fallbackCards.value[0]) {
      showFallback.value = true

      return
    }

    showErrorState.value = true
  }

  function onCardLoaded() {
    if (firstTabStatus.value === 'pending') {
      firstTabStatus.value = 'success'
    }
  }

  return {
    showFallback,
    showErrorState,
    resetFallbackErrorState,
    onCardError,
    onCardLoaded,
    firstTabStatus,
  }
}
